/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'check': {
    viewBox: '0 0 32 32',
    data: `<g><path d="M14.1,22.4l-5.8-4.6c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.4,1-0.5,1.4-0.2l4.2,3.4l8.4-10.2c0.4-0.4,1-0.5,1.4-0.1s0.5,1,0.1,1.4 L14.1,22.4z"/></g>`
  }
})
